/**
 * Formate un montant avec espace comme séparateur de milliers et point comme séparateur décimal
 * @param {number} amount - Le montant à formater
 * @param {number} [decimals=2] - Le nombre de décimales (par défaut 2)
 * @returns {string} Le montant formaté
 * 
 * @example
 * formatAmount(1234567.89) // "1 234 567.89"
 * formatAmount(1234.5, 1) // "1 234.5"
 * formatAmount(1234) // "1 234.00"
 */
export function formatAmount(amount, decimals = 2) {
  // Si le montant est null, undefined ou NaN, retourner 0 formaté
  if (amount == null || isNaN(amount)) {
    return (0).toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, " ")
  }

  // Convertir en nombre si c'est une string
  const num = typeof amount === "string" ? parseFloat(amount) : amount

  // Formater avec le bon nombre de décimales
  const withDecimals = num.toFixed(decimals)

  // Séparer la partie entière et décimale
  const [integerPart, decimalPart] = withDecimals.split(".")

  // Ajouter les espaces comme séparateur de milliers
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ")

  // Recombiner avec le point décimal
  return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger
}

// Export d'une version avec 2 décimales par défaut pour la rétrocompatibilité
export const formatAmountDefault = (amount) => formatAmount(amount, 2) 